import * as React from "react";
import {
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { ImagesContext } from "../Context";
import InputMask from "react-input-mask";

interface Props {
  organization: any;
}

const OrganizationInformation: React.FC<Props> = ({ organization }) => {
  const images = React.useContext(ImagesContext);

  const [expanded, setExpanded] = React.useState(false);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: "4px",
      }}
    >
      <Box
        className="profile-list-tile"
        sx={{
          boxShadow: expanded && "0px 7px 7px 0px #00000040",
        }}
      >
        <Box
          sx={{
            display: "flex",
            columnGap: "16px",
            alignItems: "center",
          }}
        >
          <div className="item-icon-container">
            <img
              src={images.organization_information_icon}
              alt="Insurance Icon"
              className="action-icon-image"
              style={{ width: 23, maxHeight: 23 }}
            />
          </div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: "10px",
            }}
          >
            <Box display="flex" alignItems="center" columnGap="16px">
              <Typography
                sx={{
                  fontSize: "18px",
                  lineHeight: "18px",
                  fontWeight: 700,
                  letterSpacing: "1px",
                  color: "#4A4442",
                }}
              >
                Organization Information
              </Typography>
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: "18px",
                fontWeight: 500,
                letterSpacing: "1px",
                color: "#707070",
              }}
            >
              View your organization’s general details
            </Typography>
          </Box>
        </Box>

        <Button className="expand-button" onClick={handleExpand}>
          {expanded ? "Close" : "View"}
        </Button>
      </Box>

      {expanded && (
        <Box className="edit-container">
          <Grid item xs={12} className="profile-edit-container">
            <Grid container>
              <Grid
                container
                className="profile-form-container"
                columnSpacing={3}
              >
                <Grid item xs={2}>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel htmlFor="name" className="field-label">
                        Name*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="name"
                        size="small"
                        value={organization.name}
                        disabled
                        className="the-field"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel htmlFor="address" className="field-label">
                        Address*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="address"
                        size="small"
                        value={organization.address}
                        disabled
                        className="the-field"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  {organization.address_line_2 && (
                    <Grid container>
                      <Grid item xs={12}>
                        <InputLabel htmlFor="address_line_2" className="field-label">
                          Address Line 2
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12} className="field-container">
                        <TextField
                          id="address_line_2"
                          size="small"
                          value={organization.address_line_2}
                          disabled
                          className="the-field"
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>

                <Grid item xs={2}>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel htmlFor="city" className="field-label">
                        City*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="city"
                        size="small"
                        value={organization.city}
                        disabled
                        variant="outlined"
                        className="the-field"
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel htmlFor="state" className="field-label">
                        State*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="state"
                        size="small"
                        value={organization.state}
                        disabled
                        variant="outlined"
                        className="the-field"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={2}>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel htmlFor="zipCode" className="field-label">
                        Zipcode*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="zipCode"
                        size="small"
                        value={organization.zip}
                        disabled
                        variant="outlined"
                        className="the-field"
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel htmlFor="county" className="field-label">
                        County*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="county"
                        className="the-field"
                        value={organization.county}
                        size="small"
                        variant="outlined"
                        disabled
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={2}>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="phone_number"
                        className="field-label"
                      >
                        Phone Number*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <InputMask
                        id="state"
                        mask="999-999-9999"
                        value={organization.phone_number}
                        disabled
                        maskChar=""
                        variant="outlined"
                        className="the-field"
                        size="small"
                      >
                        {() => (
                          <TextField
                            variant="outlined"
                            size="small"
                            className="the-field"
                            disabled
                          />
                        )}
                      </InputMask>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="federal_tax_id"
                        className="field-label"
                      >
                        Federal Tax ID #*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="federal_tax_id"
                        size="small"
                        value={organization.federal_tax_id}
                        disabled
                        className="the-field"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={2}>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="facility_npi"
                        className="field-label"
                      >
                        Facility NPI*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="facility_npi"
                        size="small"
                        value={organization.facility_npi}
                        disabled
                        className="the-field"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="place_of_service_code"
                        className="field-label"
                      >
                        Place of Service Code*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="place_of_service_code"
                        size="small"
                        value={organization.place_of_service_code}
                        disabled
                        className="the-field"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={2}>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel htmlFor="first_name" className="field-label">
                        Notes*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="first_name"
                        size="small"
                        value={organization.notes}
                        disabled
                        className="the-field"
                        variant="outlined"
                        multiline
                        rows={3}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            padding: "0px !important",
                          },
                          "& .MuiInputBase-inputMultiline": {
                            padding: "10.5px !important",
                            fontSize: "14px",
                            lineHeight: "19px",
                            height: "107px !important",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default OrganizationInformation;
